// 分页
export function pagination(pageNo, pageSize, array) {
    const offset = (pageNo - 1) * pageSize
    return (offset + pageSize >= array.length) ? array.slice(offset, array.length) : array.slice(offset, offset + pageSize)
}